import API from '@aws-amplify/api';
import find from 'lodash/find';
import { FAQItem } from 'models';
// import brandData from './dummy/brands.json';
import axios from 'axios';
import awsconfig from '../aws-exports';
import get from 'lodash/get';
import { CDN_ENABLED } from 'environment';

import debug from 'debug';
import { BrandImage } from 'models';
const d = debug('graphqlAPI');

export const getBrandsCached = async (brandList: string[]): Promise<BrandImage[]> => {
  if (CDN_ENABLED()) {
    return axios
      .get(awsconfig['aws_content_delivery_url'] + '/cache/brands.json')
      .then((response) => {
        d('cdnBrandResponse', response);
        const brands = get(response, 'data.data', false);
        if (brands) {
          const all = brandList.indexOf('all') !== -1;
          if (all) return brands;
          return brandList
            .map((brand) => {
              return find(brands, ['brand', brand]);
            })
            .filter((brandItem) => !!brandItem);
        } else {
          return getBrandsByAPI(brandList);
        }
      })
      .catch((err) => {
        d('caught', err);
        return getBrandsByAPI(brandList);
        // throw new Error(err);
      });
  } else {
    return getBrandsByAPI(brandList);
  }
};

// export const getBrands = async (brandList: string[]): Promise<BrandImage[]> => {
//   // console.debug('getBrands', brandList);
//   try {
//     const options: ListBrandImagesQueryVariables = {
//       filter: {
//         or: brandList.map((brandValue) => {
//           return {
//             brand: {
//               eq: brandValue,
//             },
//           };
//         }),
//       },
//     };
//     const brandQuery = /* GraphQL */ `
//       query ListBrandImages($filter: ModelBrandImageFilterInput, $limit: Int, $nextToken: String) {
//         listBrandImages(filter: $filter, limit: $limit, nextToken: $nextToken) {
//           items {
//             brand
//             image
//           }
//           nextToken
//           startedAt
//         }
//       }
//     `;
//     const result: any = await API.graphql({
//       ...graphqlOperation(brandQuery, options),
//     });
//     const resultData: ListBrandImagesQuery = result.data;
//     // @ts-ignore
//     if (resultData.listBrandImages?.items) return resultData.listBrandImages?.items || [];
//     return [];
//     // return resultData.listBrandImages?.items;
//   } catch (err) {
//     throw new Error('Error loading Brands');
//   }
// };

export const getBrandsByAPI = async (brandList: string[]): Promise<BrandImage[]> => {
  const cacheCrusher = '?_' + new Date().getTime();
  const all = brandList.indexOf('all') !== -1;
  return API.get('content', '/brands' + cacheCrusher, {}).then((res) => {
    d('getBrandsByAPI', res);
    if (!res) throw new Error('ERROR_LOADING_BRANDS');
    const brands = get(res, 'data', false);
    if (brands) {
      if (all) return brands;
      return brandList
        .map((brand) => {
          return find(brands, ['brand', brand]);
        })
        .filter((brandItem) => !!brandItem);
    } else {
      throw new Error('ERROR_LOADING_BRANDS');
    }
  });
};

export const getFAQsForTags = async (tags: string[]): Promise<FAQItem[]> => {
  const tagsFound: FAQItem[] = [];
  for (const idx in tags) {
    const tag = tags[idx];
    const faqItems = await getFAQsByTagCached(tag);
    if (faqItems) {
      // faqItems.items?.forEach((faq) => {
      faqItems.forEach((faq) => {
        if (faq && !find(tagsFound, ['id', faq.id]))
          tagsFound.push({
            id: faq.id,
            question: faq.question,
            answer: faq.answer,
            group: faq.group || '',
          });
      });
    }
  }
  return tagsFound;
};

export const getFAQsByTagCached = async (tag: string): Promise<FAQItem[]> => {
  if (CDN_ENABLED()) {
    return axios
      .get(awsconfig['aws_content_delivery_url'] + '/cache/faqs/' + tag + '.json')
      .then((response) => {
        const tags = get(response, 'data.data', false);
        if (tags) {
          return tags;
        } else {
          d('cachedCopyNotFound', tag);
          return getFAQsByTagByAPI(tag);
        }
      })
      .catch((err) => {
        d('caught', err);
        return getFAQsByTagByAPI(tag);
        // throw new Error(err);
      });
  } else {
    return getFAQsByTagByAPI(tag);
  }
};

export const getFAQsByTagByAPI = async (tag: string): Promise<FAQItem[]> => {
  const cacheCrusher = '?_' + new Date().getTime();
  return API.get('content', '/faqs/' + tag + cacheCrusher, {}).then((res) => {
    if (!res) throw new Error('ERROR_LOADING_TAGS');
    const faqItemsFilteredByTagAndStatus = get(res, 'data', false)
      // NOTE - these options should be moved to the backend
      // @ts-ignore - add by JT - causing build errors...
      .filter((item: FAQItem) => !item._deleted)
      // @ts-ignore - add by JT - causing build errors...
      .sort((a: FAQItem, b: FAQItem) => {
        return Number(a.order) - Number(b.order);
      });
    if (faqItemsFilteredByTagAndStatus) {
      return faqItemsFilteredByTagAndStatus;
    } else {
      throw new Error('ERROR_LOADING_TAGS');
    }
  });
};

// export const getFAQsByTag = async (tag: string): Promise<ListFAQItemsQuery['listFAQItems']> => {
//   try {
//     const options: ListFAQItemsQueryVariables = {
//       filter: {
//         tags: {
//           contains: tag,
//         },
//       },
//     };
//     const result: any = await API.graphql({
//       ...graphqlOperation(listFAQItems, options),
//     });
//     const resultData: ListFAQItemsQuery = result.data;
//     return resultData.listFAQItems;
//   } catch (err) {
//     throw new Error('Error loading FAQs');
//   }
// };
